module.exports = __webpack_public_path__ + "static/diamond-04199d3b2afbcbfaf44fc4a777404197.svg";